<template>
    <Modal :visible="visible" @close="closeModal">
        <div
            class="d-flex flex-column align-items-center justify-content-center"
        >
            <i
                class="fi fi-lg mb-2"
                style="font-size: 34px; line-height: 34px"
                :class="icon"
            ></i>
            <h2 class="my-1 text-center">{{ title }}</h2>
            <div
                class="mt-2 text-center mb-3 w-100"
                style="color: var(--neutral-800)"
            >
                <slot></slot>
            </div>
            <div>
                <button
                    type="button"
                    class="btn btn-desktop-lg btn-white me-2"
                    @click="closeModal"
                >
                    No
                </button>
                <button
                    type="button"
                    class="btn btn-desktop-lg btn-primary"
                    :disabled="confirmDisabled"
                    @click="confirmAction"
                >
                    {{ confirmButtonText }}
                </button>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
    name: 'ConfirmModal',
    components: {
        Modal,
    },
    props: {
        title: {
            type: String,
            default: 'Confirm?',
        },
        confirmButtonText: {
            type: String,
            default: 'Confirm',
        },
        visible: {
            type: Boolean,
            required: true,
        },
        icon: {
            type: String,
            default: 'fi-alert-circle text-danger',
        },
        confirmDisabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
    methods: {
        closeModal() {
            this.$emit('close');
        },
        confirmAction() {
            this.$emit('confirm');
        },
    },
};
</script>
